import { AxiosError } from 'axios';
import { useQuery } from 'react-query';
import { Axios } from '@utils/api/axios-instance';
import { GET_URL_NEW } from '@utils/api/endpoints';
import { BaseError } from '@utils/types/shared/base';
import { AdminExceedanceSummaryResponse } from '@utils/types/back-office/exceedances';
import { useNewAppSearchParams } from '@utils/hooks/use-new-app-search-params.ts';

export const useGetAdminExceedances = () => {
  const { searchParams } = useNewAppSearchParams();

  const offset = Number.isFinite(Number(searchParams.offset))
    ? Number(searchParams.offset)
    : 0;
  const limit = Number.isFinite(Number(searchParams.limit))
    ? Number(searchParams.limit)
    : 25;

  const sortField = (searchParams.sort as string | undefined) || undefined;
  const sortDirection =
    (searchParams.direction as 'asc' | 'desc' | undefined) || undefined;

  const qString = (searchParams.q as string | undefined)?.trim() || undefined;

  const fetchExceedances = async () => {
    const { adminExceedances } = GET_URL_NEW({
      offset,
      limit,
      q: qString,
      sort: sortField,
      direction: sortDirection
    });
    const { data } =
      await Axios.get<AdminExceedanceSummaryResponse>(adminExceedances);
    return data;
  };

  return useQuery<AdminExceedanceSummaryResponse, AxiosError<BaseError>>(
    ['adminExceedances', offset, limit, qString, sortField, sortDirection],
    fetchExceedances,
    {
      staleTime: 60_000,
      cacheTime: 5 * 60 * 1000,
      keepPreviousData: true,
      refetchOnWindowFocus: true
    }
  );
};
